import { track } from "../track";

type Params =
  | {
      type: "basic";
      email: string;
    }
  | {
      type: "google";
      quiz_id?: string;
    };

export const trackLogInTry = (params: Params) =>
  track({ event: "log_in_try", ...params });
